import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import {
	wrapperStyles,
	labelStyles,
	inputStyles,
	errorStyles,
	optionalEditStyles,
	labelEditStyles,
	inputEditStyles,
	inputSizeStyles,
	inputSizeEditStyles,
} from '@/css/shared/inputs.css';

const getStyles = (formStyles) =>
	css(wrapperStyles(formStyles), inputSizeStyles(), {
		'.supt-inputEmail__label': labelStyles(formStyles),
		'.supt-inputEmail__input': inputStyles(formStyles),
		'.supt-inputEmail__error': errorStyles(formStyles),

		'&.supt-inputField--error': {
			'.supt-inputEmail__input': {
				borderColor: formStyles.error?.color,
			},
		},
	});

// edit
const getEditStyles = (formStyles) =>
	css({
		'.supt-inputEmail__optional': optionalEditStyles(formStyles),
		'.supt-inputEmail__input': inputEditStyles(formStyles),
		'.supt-inputEmail__label': labelEditStyles(),
	});

const getEditGlobalStyles = () =>
	cssObj({
		'.wp-block[data-type="supt/input-email"]': inputSizeEditStyles(),
	});

export { getStyles, getEditStyles, getEditGlobalStyles };
